function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.559 3.28982C60.2412 6.05255 58.3568 10 58.3568 10C58.3568 10 52.1229 9.47129 49.4407 6.71018C46.7585 3.94908 48.6437 0 48.6437 0C48.6437 0 54.8768 0.528711 57.559 3.28982Z",
  fill: "#00A65A"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.258 2C59.8049 10.1794 47.3636 19.7561 47.2746 19.851L53.3935 22.5462C53.7703 22.1462 62.7205 12.0837 67.3828 3.52539L64.258 2Z",
  fill: "#663325"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.4681 11.904C36.9925 11.9156 19.1859 12.64 13.9629 36.1643C11.4433 45.5835 -0.267217 50.5579 0.00465792 58.2409C0.242549 64.9559 9.45876 65.8579 14.0724 65.7846C34.7613 65.4635 62.1 54.5383 63.3316 31.0168C63.8929 20.2969 54.0732 11.8779 42.4681 11.904Z",
  fill: "#FFC107"
});

var SvgMango = function SvgMango(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 68,
    height: 66,
    viewBox: "0 0 68 66",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMango, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mango.e338d19e.svg";
export { ForwardRef as ReactComponent };